__webpack_require__.p = "/Marvel-Inform-portal/";